import { AppConstants } from 'cd-eft/appConstants';
import stores from 'cd-eft/models/Stores';
import { Screenshot } from './Screenshot';
import { TerraceDesignToolsController } from 'cd-eft/services/eftSetApi';
import { getTerraceMapExtent } from 'cd-eft/components/Design/Terrace/TerraceDesignProfileView/TerraceDesignProfileViewVM';
import sleep from 'cd-eft/utils/sleep';

import MapView from '@arcgis/core/views/MapView';
import Layer from '@arcgis/core/layers/Layer';
import GroupLayer from '@arcgis/core/layers/GroupLayer';
import Extent from '@arcgis/core/geometry/Extent';

const { designStore, terraceDesignStore } = stores.AppStore;


export async function createAllTerraceScreenshot(mapView: MapView) {
    const layersToDelete: Layer[] = [];
    const layersToTurnOff: Layer[] = [];
    const layersToTurnOn: Layer[] = [];

    let fullExtent: Extent | undefined;

    const response = await TerraceDesignToolsController.getTerraceDesignSummariesBySessionUuidUsingGET(
        designStore.projectsStore.currentSessionId
    );
    if (response && response.data) {
        for (const terrace of response.data) {
            if ((terrace.alignedElementDesignParamsId === undefined) || (terrace.alignedElementDesignParamsId < 1)) {
                continue;
            }
            let terraceLayer: Layer | undefined;
            const groupLayerId = `Terrace${terrace.alignedElementDesignParamsId}`;
            terraceLayer = mapView.map.findLayerById(groupLayerId);
            if (terraceLayer === undefined) {
                try {
                    const calculateResp = await TerraceDesignToolsController.calculateTerraceChannelShapeUsingPOST(
                        terrace.alignedElementDesignParamsId
                    );
                    if ((calculateResp !== undefined) &&
                        (calculateResp.data !== undefined) &&
                        (calculateResp.data.terraceStructureShapeDTO !== undefined)) {
                        const layerTitle = ((terrace.name === undefined) ?
                            `Terrace ${terrace.alignedElementDesignParamsId}` :
                            (terrace.name.length > 0 ? terrace.name : `Terrace ${terrace.alignedElementDesignParamsId}`));
                        terraceLayer = terraceDesignStore.addTerraceToMap(
                            calculateResp.data.terraceStructureShapeDTO,
                            mapView,
                            terrace.alignedElementDesignParamsId,
                            layerTitle
                        );
                    }
                    if (terraceLayer !== undefined) {
                        layersToDelete.push(terraceLayer);
                    }
                } catch {
                    // pass
                }
            } else {
                if (!(terraceLayer.visible)) {
                    terraceLayer.visible = true;
                    layersToTurnOff.push(terraceLayer);
                }
            }

            if (terraceLayer !== undefined) {
                const terraceExtent = getTerraceMapExtent(terraceLayer as GroupLayer);
                if (terraceExtent !== undefined) {
                    if (fullExtent === undefined) {
                        fullExtent = terraceExtent;
                    } else {
                        fullExtent = fullExtent.union(terraceExtent);
                    }
                }
            }
        }
        const layersOff: string[] = [
            AppConstants.BreaklineLayerId,
            AppConstants.SurveyPointsLayerId,
            AppConstants.OriginalTinTrianglesLayerId,
            AppConstants.DesignedTinTrianglesLayerId,
            AppConstants.SurfaceLayerId,
            AppConstants.OriginalContourLayerId,
            // AppConstants.DesignedContourLayerId,
            AppConstants.SurfaceTinElevationLayerId
        ];
        turnLayersOff(mapView, layersToTurnOn, layersOff);

        if (fullExtent !== undefined) {
            fullExtent.expand(1.1);
            mapView.goTo(fullExtent);
            await sleep(2000); // let it redraw
        }

        await Screenshot.takeFullViewScreenshot(mapView, designStore.projectsStore.currentSessionId as string);
    } else {
        throw new Error();
    }

    turnLayersOnOff(layersToTurnOff, false);
    turnLayersOnOff(layersToTurnOn, true);
    deleteLayersFromMap(mapView, layersToDelete);
}

export function turnLayersOnOff(layers: Layer[], on: boolean) {
    layers.forEach((l) => { l.visible = on; });
}

export function turnLayersOff(mapView: MapView, layersToTurnOn: Layer[], layers: string[]) {
    layers.forEach((l) => {
        const layer = mapView.map.findLayerById(l);
        if ((layer !== undefined) && layer.visible) {
            layer.visible = false;
            layersToTurnOn.push(layer);
        }
    });
}

export function deleteLayersFromMap(mapView: MapView, layers: Layer[]) {
    layers.forEach((l) => {
        mapView.map.remove(l);
        // l.destroy();
    });
}
